// Sales Quotes GraphQL mutations

import { gql } from "@apollo/client"

export const CREATE_SALES_QUOTE = gql`
  mutation CreateSalesQuote($input: CreateSalesQuoteFromOpportunityInput!) {
    createSalesQuoteFromOpportunity(input: $input)
  }
`

export const UPDATE_SALES_QUOTE = gql`
  mutation UpdateSalesQuote($input: UpdateSalesQuoteInput!) {
    updateSalesQuote(input: $input) {
      id
      quoteNbr
      businessAccount
      contactContact
      date
      description
      total
      status
      opportunityID
      expirationDate
      note
      contactID
      currency
      location
      ownerID
      ownerContact
      textHeader
      textFooter
    }
  }
`
